const getShowAlertBadge = (prospect) => {
    if (!prospect)
        return false;
    if (prospect?.rtm_prospect_status === 'IN_REELECTION' &&
        ['rejected_by_provider', 'expired_lead'].includes(prospect?.rtm_reelection_scenario || '')) {
        return true;
    }
    return false;
};
export default getShowAlertBadge;
